import CameraList from "../../components/cameras/CameraList";

export const CamerasPage: React.FC = () => {
    return (
        <div className="m-3">
            <CameraList />
        </div>
    );
};
